import { Footer, Header } from "../../components";
import { HeaderType } from "../../components/Header/Header";
import { Section } from "../../components/common";
import { PrivacyPolicyStyle } from "./PrivacyPolicy.style";

const PrivacyPolicy = () => {
  return (
    <PrivacyPolicyStyle>
      <Header
        heading="Privacy Policy"
        image="/images/banners/terms-and-conditions.png"
        type={HeaderType.inner}
      />

      <Section className="testimonial-wrapper">
        <h3>Privacy Policy</h3>

        <p>
          <strong>Super Hauling Inc</strong>
        </p>

        <p>
          <strong>Effective Date:</strong> August 19, 2026
        </p>

        <p>
          Super Hauling Inc website is owned and operated by Super Hauling Inc, which is the data controller of your personal
          information. We are committed to protecting your privacy and ensuring
          that your personal data is handled securely and responsibly. This
          Privacy Policy explains how we collect, use, maintain, and safeguard
          your information when you interact with us through our website, SMS,
          phone communications, Meta ads campaigns, and third-party vendors.
        </p>

        <h3>1. Information We Collect</h3>
        <p>We may collect the following information:</p>
        <ul>
          <li>Name, phone number, email address, and contact details</li>
          <li>Vehicle details and transport requirements</li>
          <li>Pickup and delivery addresses and scheduling details</li>
          <li>
            Information submitted through website forms, Meta ads, dialers, or
            third-party vendors
          </li>
          <li>
            Device information such as IP address, browser type, cookies, and
            usage behavior
          </li>
        </ul>

        <h3>2. How We Use Your Information</h3>
        <p>We use your information to:</p>
        <ul>
          <li>
            Provide vehicle transport quotes, scheduling, dispatch, pickup, and
            delivery updates
          </li>
          <li>
            Send SMS messages regarding quotes, appointment reminders, dispatch
            coordination, and customer support
          </li>
          <li>Connect customers with drivers, dispatchers, and carriers</li>
          <li>Respond to inquiries and provide customer service</li>
          <li>Improve our services, operations, and website performance</li>
          <li>Maintain internal business records and legal compliance</li>
        </ul>

        <p>
          <strong>
            All SMS messages include clear instructions to opt out by replying
            STOP or receive help by replying HELP.
          </strong>
        </p>

        <h3>3. Sharing and Disclosure of Information</h3>

        <p>
          <strong>
            We do NOT sell, rent, or share your personal information for
            marketing purposes.
          </strong>
        </p>

        <p>
          <strong>
            No mobile information will be shared with third parties/affiliates
            for marketing/promotional purposes. All the above categories exclude
            text messaging originator opt-in data and consent; this information
            will not be shared with any third parties.
          </strong>
        </p>

        <p>
          <strong>
            SMS consent and phone numbers collected for SMS communication
            purposes will not be shared with any third party or affiliates for
            marketing purposes.
          </strong>
        </p>

        <p>We may share your information only when necessary with:</p>

        <ul>
          <li>
            Drivers, carriers, dispatchers, or transport coordinators involved
            in fulfilling your transport request
          </li>
          <li>
            Trusted service providers required to operate our website or
            business
          </li>
          <li>Legal authorities when required by law or regulation</li>
        </ul>

        <h3>4. Consent, SMS Communication & Opt-Out</h3>

        <p>
          By submitting your information through our website, quote forms, Meta
          ads campaigns, dialers, or third-party vendors, you expressly consent
          to receive conversational SMS messages from Super Hauling Inc, including:
        </p>

        <ul>
          <li>Vehicle transport quotes</li>
          <li>Carrier dispatch updates</li>
          <li>Pickup and delivery notifications</li>
          <li>Appointment reminders</li>
          <li>Customer support communications</li>
        </ul>

        <p>
          <strong>
            Message frequency may vary. You may receive up to 10 SMS messages
            per week.
          </strong>
        </p>

        <p>
          <strong>Message and data rates may apply.</strong>
        </p>

        <p>
          <strong>Consent is not a condition of purchase.</strong>
        </p>

        <ul>
          <li>
            Reply <strong>STOP</strong> to unsubscribe
          </li>
          <li>
            Reply <strong>HELP</strong> for assistance
          </li>
        </ul>

        <h3>5. Security of Your Information</h3>

        <p>
          We implement reasonable administrative, technical, and physical
          safeguards to protect your personal information from unauthorized
          access, misuse, disclosure, or alteration. While we strive to protect
          your data, no internet transmission or storage method is 100%
          guaranteed secure.
        </p>

        <h3>6. Retention of Information</h3>

        <p>
          We retain your personal information only for as long as necessary to:
        </p>

        <ul>
          <li>Provide our transport and support services</li>
          <li>Comply with legal obligations</li>
          <li>Resolve disputes</li>
          <li>Enforce our agreements and policies</li>
        </ul>

        <h3>7. Cookies & Website Analytics</h3>

        <p>
          Our website may use cookies, analytics tools, and browser tracking
          technologies to improve user experience, monitor performance, and
          optimize website functionality. This information does not override our
          commitment to protecting your personal privacy.
        </p>

        <h3>8. Changes to This Privacy Policy</h3>

        <p>
          We may update this Privacy Policy periodically to reflect changes in
          legal, operational, or service requirements. Any updates will be
          posted on this page with the revised Effective Date.
        </p>

        <h3>9. Contact Information</h3>

        <p>
          If you have questions regarding this Privacy Policy, your personal
          data, or SMS communications, please contact:
        </p>

        <p>
          <strong>Super Hauling Inc</strong>
        </p>

              <p>Email: info@superspeedhauling.us</p>

        <p>Phone: (888) 693-9563</p>

        <p>USDOT: 9016315</p>

        <p>MC: 57541812</p>

        <p>
          Address: Super Hauling Inc, 500 Rawhide Ln, Florence, TX 76527
        </p>

              <p>Website: superspeedhauling.us</p>
      </Section>

      <Footer />
    </PrivacyPolicyStyle>
  );
};

export default PrivacyPolicy;


